// src/utils/sorting.ts

/**
 * Sorts year/folder strings with numeric years first (descending),
 * followed by non-numeric folders (alphabetical ascending).
 * Does NOT mutate the input array.
 */
export function sortYearsDescending(years: string[]): string[] {
  const numeric: string[] = [];
  const alpha: string[] = [];

  for (const y of years) {
    if (/^\d+$/.test(y)) {
      numeric.push(y);
    } else {
      alpha.push(y);
    }
  }

  // Numeric years descending
  numeric.sort((a, b) => Number(b) - Number(a));
  // Alphabetic folders ascending (case-insensitive)
  alpha.sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));

  return [...numeric, ...alpha];
}

/**
 * Sorts event name strings in ascending case-insensitive alphabetical order.
 * Does NOT mutate the input array.
 */
export function sortEventsAscending(events: string[]): string[] {
  return [...events].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));
}

/**
 * Sorts photo filename strings in ascending lexicographic order.
 * Does NOT mutate the input array.
 */
export function sortPhotosAscending(filenames: string[]): string[] {
  return [...filenames].sort((a, b) => a.localeCompare(b));
}
